<template>
    <div>
        <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="MAESTRO DE LISTAS DE VALORES" key="1">
                <g-master :name="lType.name"  @params="paramsTable" :endpoint="lType.endpoint" :tableSetup.sync="lType.tableSetup"
                          :modalWidth="800">
                  <template slot="customButton">
                    <g-btn-excel :endpoint="lTypeEndpointExcel" :params="lTypeParamsExcel" :fileName="lTypeFileNameExcel"/>
                  </template>
                    <template slot="masterModal" slot-scope="{record}">
                        <a-row :gutter="24">
                            <a-col v-bind="colOptions">
                                <a-form-item v-bind="fiOptions" label="Descripción">
                                    <a-input v-decorator="lType.decorators.description"/>
                                </a-form-item>
                            </a-col>
                            <a-col v-bind="colOptions">
                                <a-form-item v-bind="fiOptions" label="Estado">
                                    <a-input v-decorator="lType.decorators.status"/>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </template>
                </g-master>
            </a-tab-pane>
        </a-tabs>
        <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="LISTAS DE VALORES" key="1">
                <g-master :name="lookup.name"  @params="paramsTableHijo" :endpoint="lookup.endpoint" :tableSetup.sync="lookup.tableSetup"
                          :modalWidth="800" :parentData="parentData">
                  <template slot="customButton">
                    <g-btn-excel :endpoint="lookupEndpointExcel" :params="lookupeParamsExcel" :fileName="lookupFileNameExcel"/>
                  </template>
                    <template slot="masterModal" slot-scope="{record}">
                        <a-row :gutter="24">
                            <a-col v-bind="colOptions">
                                <a-form-item v-bind="fiOptions" label="Code">
                                    <a-input v-decorator="lookup.decorators.code"/>
                                </a-form-item>
                            </a-col>
                            <a-col v-bind="colOptions">
                                <a-form-item v-bind="fiOptions" label="Equivalencia">
                                    <a-input v-decorator="lookup.decorators.equivalency"/>
                                </a-form-item>
                            </a-col>
                            <a-col v-bind="colOptions">
                                <a-form-item v-bind="fiOptions" label="Estado">
                                    <a-input v-decorator="lookup.decorators.status"/>
                                </a-form-item>
                            </a-col>
                            <a-col v-bind="colOptions">
                                <a-form-item v-bind="fiOptions" label="L. Father">
                                    <a-input v-decorator="lookup.decorators.id_h_lookup_father"/>
                                </a-form-item>
                            </a-col>
                            <a-col v-bind="colOptions">
                                <a-form-item v-bind="fiOptions" label="Descripción">
                                    <a-input v-decorator="lookup.decorators.description"/>
                                </a-form-item>
                            </a-col>
                          <a-col v-bind="colOptions">
                            <g-dropdown :label="$t('Compañía')"
                                        :formItemConfig="fiOptions"
                                        endpoint="company"
                                        :decorator="lType.decorators.company">
                            </g-dropdown>
                          </a-col>
                        </a-row>
                    </template>
                </g-master>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>
<script>
  const rules = [{required: true, message: 'Valor Requerido'}]
  export default {
    data () {
      return {
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {span: 6},
          'wrapper-col': {span: 18},
          'has-feedback': true
        },
        lType: {
          name: 'hierarchy_lookuptype',
          endpoint: 'hierarchy_lookuptype',
          tableSetup: {
            columns: [
              {title: 'Código', dataIndex: 'id_h_lookup_type', sorter: true, width: 120},
              {title: 'Estado', dataIndex: 'status', sorter: true, width: 120},
              {title: 'Descripción', dataIndex: 'description', sorter: true}
            ],
            tableConfig: {
              scroll: {x: 720, y: 250},
              rowKey: 'id_h_lookup_type'
            },
            allowSelect: true,
            selectType: 'radio',
            selectedRowKeys: [],
            selectedRows: []
          },
          decorators: {
            description: ['description', {rules: rules}],
            status: ['status', {rules: rules}],
            company: ['id_company', {rules: rules}]
          }
        },
        lookup: {
          name: 'hierarchy_lookup',
          endpoint: 'hierarchy_lookup',
          tableSetup: {
            columns: [
              {title: 'Código', dataIndex: 'id_h_lookup', sorter: true, width: 120},
              {title: 'Code', dataIndex: 'code', sorter: true, width: 120},
              {title: 'Equivalencia', dataIndex: 'equivalency', sorter: true, width: 150},
              {title: 'L. Father', dataIndex: 'h_lookup_father', sorter: true, width: 120},
              {title: 'Estado', dataIndex: 'status', sorter: true, width: 120},
              {title: 'Descripción', dataIndex: 'description', sorter: true}
            ],
            tableConfig: {
              scroll: {x: 1000, y: 250},
              rowKey: 'id_h_lookup'
            }
          },
          decorators: {
            code: ['code'],
            equivalency: ['equivalency'],
            id_h_lookup_father: ['id_h_lookup_father'],
            status: ['status', {rules: rules}],
            description: ['description', {rules: rules}]
          }
        },
        lTypeEndpointExcel: 'hierarchy_lookuptype_/downloadExcel',
        lTypeFileNameExcel: 'MaestroListaValores',
        lookupEndpointExcel: 'hierarchy_lookup_/downloadExcel',
        lookupFileNameExcel: 'ListaDeValores',
        paramsT: {},
        paramsTHijo: {}
      }
    },
    methods: {
      paramsTable (params) {
        this.paramsT = params
      },
      paramsTableHijo (params) {
        this.paramsTHijo = params
      }
    },
    computed: {
      parentData () {
        if (this.lType.tableSetup.selectedRowKeys && this.lType.tableSetup.selectedRowKeys.length > 0) {
          return {
            id_h_lookup_type: this.lType.tableSetup.selectedRowKeys[0]
          }
        }
        return {id_h_lookup_type: -1}
      },
      lTypeParamsExcel () {
        return {...this.paramsT, columns: this.lType.tableSetup.columns}
      },
      lookupeParamsExcel () {
        return {...this.paramsTHijo, columns: this.lookup.tableSetup.columns, ...this.parentData}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/HierarchyLookupType/HierarchyLookupType.vue